import {
  convertLabelMapToConfig,
  convertLabelUomMapToConfig,
  mergeConfig,
} from 'Components/Worksheets/Core/Helpers/configHelpers';

const getLabelConfig = (prefix: string) =>
  mergeConfig(
    convertLabelMapToConfig({
      [`${prefix}.Preparation.FineGrainSize`]: `Test Portion Grain Size`,
      [`${prefix}.Preparation.CopyGrainSize`]: `Copy grain size from <20mm water content`,
      [`${prefix}.Preparation.IsSampleSusceptibleToCrushing`]: `Sample Susceptible to Crushing?`,
      [`${prefix}.Preparation.UsedSubSamples`]: `Sub-Samples Used`,
      [`${prefix}.Preparation.StabiliserUsed`]: `Stabilized Material`,
      [`${prefix}.Preparation.StabiliserType`]: `Stabilizer Type`,
      [`${prefix}.Preparation.StabiliserAmount`]: `Stabilizer Amount (%)`,
      [`${prefix}.Preparation.TareMass`]: `Tare Mass`,
      [`${prefix}.Preparation.TareAndTotalSampleMass`]: `Tare and Total Sample Mass`,
      [`${prefix}.Preparation.TotalSampleMass`]: `Total Sample Mass`,
      [`${prefix}.Preparation.AssociatedOversizeDetermination.MeasuredTest.TotalMaterialDryMass`]:
        'Total Sample Dry Mass',
      [`${prefix}.Preparation.AssociatedOversizeDetermination.MeasuredTest.Sieves.DryMassPassing`]:
        'Passing 20mm Material Dry Mass',
      [`${prefix}.Preparation.GradingZone`]: `Grading Zone`,
      [`${prefix}.Preparation.MouldType`]: `Mould Size`,
      [`${prefix}.Preparation.SampleDriedBy`]: `Sample Drying`,
      [`${prefix}.Preparation.AggregationsBrokenDownBy`]: `Aggregations Broken Down By`,
      [`${prefix}.Preparation.BrokenDownToPassSieveSize`]: `Broken Down to Pass Sieve Size`,
      [`${prefix}.Preparation.CumulativeMass`]: `Cumulative Mass Retained on 37.5mm Sieve`,
      [`${prefix}.Preparation.TestPortionMass`]: `Test Portion Mass`,
      [`${prefix}.Preparation.Preparation.AssociatedGradingAssessment`]: `Grading Assessment`,
      [`${prefix}.Preparation.AssociatedOversizeDetermination.ExternalTest.Results.Sieves[${0}].CumulativeDryMassPassingPercent`]: `Passing 37.5mm`,
      [`${prefix}.Preparation.AssociatedOversizeDetermination.ExternalTest.Results.Sieves[${1}].CumulativeDryMassPassingPercent`]: `Passing 20mm`,
      [`${prefix}.Preparation.AssociatedOversizeDetermination.ExternalTest.Results.Sieves[${0}].CumulativeDryMassRetainedPercent`]: `Retained 37.5mm`,
      [`${prefix}.Preparation.AssociatedOversizeDetermination.ExternalTest.Results.Sieves[${1}].CumulativeDryMassRetainedPercent`]: `Retained 20mm`,
      [`${prefix}.Preparation.OversizeDeterminationResults.Sieves[${0}].CumulativeDryMassPassingPercent`]: `Passing 37.5mm`,
      [`${prefix}.Preparation.OversizeDeterminationResults.Sieves[${1}].CumulativeDryMassPassingPercent`]: `Passing 20mm`,
      [`${prefix}.Preparation.OversizeDeterminationResults.Sieves[${0}].CumulativeDryMassRetainedPercent`]: `Retained 37.5mm`,
      [`${prefix}.Preparation.OversizeDeterminationResults.Sieves[${1}].CumulativeDryMassRetainedPercent`]: `Retained 20mm`,
      [`${prefix}.Preparation.CumulativeMassRetainedOn20mmSieve`]: `Cumulative Mass Retained on 20mm Sieve`,
      [`${prefix}.Preparation.CumulativeMassRetainedOn37_5mmSieve`]: `Cumulative Mass Retained on 37.5mm Sieve`,
      [`${prefix}.Preparation.EnterConvertedWetDensity`]: 'Enter converted wet density data',
      [`${prefix}.Preparation.VisualNominalParticleSize`]: 'Test Portion Maximum Grain Size Diameter',
      [`${prefix}.Preparation.CompleteTestByAgreementWithClient`]: 'Complete Test by Agreement with Client',
      [`${prefix}.Preparation.MaterialLargerThan37_5mm`]: 'Material Larger than 37.5mm',

      [`${prefix}.Equipment.CompactionBalance`]: 'Balance',
      [`${prefix}.Equipment.StraightEdge`]: 'Straight Edge',
      [`${prefix}.Equipment.Caliper`]: 'Callipers',
      [`${prefix}.Equipment.Hammer`]: 'Hammer',
      [`${prefix}.Equipment.HammerOperation`]: 'Operation',
      [`${prefix}.Equipment.Moulds.Moulds.Mould`]: 'Mould',
      [`${prefix}.Equipment.Moulds.Moulds.Mass`]: 'Mould Mass',
      [`${prefix}.Equipment.Moulds.Moulds.Volume`]: 'Mould Volume',
      [`${prefix}.Equipment.Moulds.Moulds.SoilHeightLimit`]: 'Limit for Soil Height',
      [`${prefix}.Equipment.Moulds.Moulds.MouldAndCollarHeight`]: 'Height of Mould and Collar',
      [`${prefix}.Equipment.Moulds.Moulds.TopOfCollarToSoilLowerLimit`]: 'Top of Collar to Soil Lower Limit',

      [`${prefix}.TestPortions.MddMouldId`]: 'Mould',
      [`${prefix}.TestPortions.PortionMass`]: 'Portion Mass',
      [`${prefix}.TestPortions.WaterAddedTargetPercent`]: 'Water Added Target',
      [`${prefix}.TestPortions.WaterAddedTarget`]: 'Water to Add',
      [`${prefix}.TestPortions.PortionMassAfterWaterAdded`]: 'Portion Mass After Addition',
      [`${prefix}.TestPortions.WaterAdded`]: 'Water Added',
      [`${prefix}.TestPortions.WaterAddedPercent`]: 'Actual Water Added',
      [`${prefix}.TestPortions.Curing.Duration`]: 'Soak Time',
      [`${prefix}.TestPortions.SoilHeightLimitChecked`]: 'Soil Height Limit Checked',
      [`${prefix}.TestPortions.WetSoilAndMouldMass`]: 'Wet Soil and Mould Mass',
      [`${prefix}.TestPortions.WetSoilMass`]: 'Wet Soil Mass',
      [`${prefix}.TestPortions.WetDensity`]: 'Wet Density',
      [`${prefix}.TestPortions.DryDensity`]: 'Dry Density',
      [`${prefix}.TestPortions.ExcludedPoint`]: 'Exclude Point',

      [`${prefix}.TestFractionParticleDensity.ParticleDensity`]: `Test Fraction Particle Density`,
      [`${prefix}.TestFractionParticleDensity.AssociatedTestFractionParticleDensity.ExternalTest.Results.ParticleDensity`]: `Particle Density`,
      [`${prefix}.TestFractionParticleDensity.ParticleDensityDeterminationMethod`]: 'Determination Method',

      [`${prefix}.Results.MaximumDryDensity`]: 'Maximum Dry Density',
      [`${prefix}.Results.OptimumMoistureContent`]: 'Optimum Water Content',
      [`${prefix}.Results.MddCurveFittingAlgorithm`]: 'Curve Fitting',

      [`cwdChart.XAxisMin`]: 'Water Added Start',
      [`cwdChart.XAxisMajorStep`]: 'Water Added Division Size',
      [`cwdChart.YAxisToXAxisStepRatio`]: 'Converted Wet Density to Water Added Ratio',

      [`mddChart.XAxisMin`]: 'Water Content Start',
      [`mddChart.XAxisMajorStep`]: 'Water Content Division Size',
      [`mddChart.YAxisToXAxisStepRatio`]: 'Dry Density to Water Content Ratio',
    }),
    convertLabelUomMapToConfig({
      [`${prefix}.Preparation.BrokenDownToPassSieveSize`]: 'mm',
      [`${prefix}.Preparation.AssociatedOversizeDetermination.ExternalTest.Results.Sieves.CumulativeDryMassPassingPercent`]:
        '%',
      [`${prefix}.Preparation.AssociatedOversizeDetermination.ExternalTest.Results.Sieves.CumulativeDryMassRetainedPercent`]:
        '%',
      [`${prefix}.Preparation.OversizeDeterminationResults.Sieves.CumulativeDryMassPassingPercent`]: '%',
      [`${prefix}.Preparation.OversizeDeterminationResults.Sieves.CumulativeDryMassRetainedPercent`]: '%',
      [`${prefix}.TestPortions.WaterAddedTargetPercent`]: '%',
      [`${prefix}.TestPortions.WaterAddedPercent`]: '%',
      [`${prefix}.Results.OptimumMoistureContent`]: '%',
      [`mddChart.XAxisMin`]: '%',
      [`mddChart.XAxisMajorStep`]: '%',
      [`cwdChart.XAxisMin`]: '%',
      [`cwdChart.XAxisMajorStep`]: '%',
    })
  );

export default getLabelConfig;
